import { JsonEditor } from 'json-edit-react';

/**
 * Reusable JSON Editor component wrapper
 * @param {Object} props
 * @param {Object} props.data - JSON data to edit
 * @param {Function} props.onChange - Callback when data changes, receives updated data object
 * @param {boolean} props.disabled - Whether the editor is disabled
 * @param {string} props.className - Additional CSS classes
 * @param {number} props.minHeight - Minimum height in pixels (default: 200)
 * @param {boolean} props.restrictEdit - Restrict editing (default: false)
 * @param {boolean} props.restrictDelete - Restrict deletion (default: false)
 * @param {boolean} props.restrictAdd - Restrict adding new keys (default: false)
 * @param {boolean} props.collapse - Collapse all nodes by default (default: false)
 */
export default function JSONEditor({
  data = {},
  onChange,
  disabled = false,
  className = '',
  minHeight = 200,
  restrictEdit = false,
  restrictDelete = false,
  restrictAdd = false,
  collapse = false
}) {
  const handleUpdate = (newData) => {
    if (onChange && !disabled) {
      onChange(newData);
    }
  };

  // Simple light theme
  const lightTheme = {
    displayName: 'Light',
    fragments: { edit: '#3b82f6' },
    styles: {
      container: {
        backgroundColor: '#ffffff',
        fontFamily: 'monospace',
        fontSize: '13px'
      },
      property: '#0f172a',
      bracket: '#64748b',
      value: '#059669',
      string: '#dc2626',
      number: '#ea580c',
      boolean: '#9333ea',
      null: '#64748b'
    }
  };

  return (
    <div
      className={`border border-slate-300 rounded-lg overflow-hidden bg-white ${className}`}
      style={{ minHeight: `${minHeight}px` }}
    >
      <JsonEditor
        data={data}
        setData={handleUpdate}
        restrictEdit={disabled || restrictEdit}
        restrictDelete={disabled || restrictDelete}
        restrictAdd={disabled || restrictAdd}
        collapse={collapse}
        rootName="settings"
        theme={lightTheme}
        className="json-editor-custom"
      />
    </div>
  );
}
